import React, { useState } from "react";
import { TextField, Button, Grid, Box, Typography } from "@mui/material";
import { useForm, Controller } from "react-hook-form";
import * as yup from "yup";
import axios from "axios";
import ReCAPTCHA from "react-google-recaptcha";
import styles from "../styles/ContactForm.module.css";
import TimezoneSelect from "./TimezoneSelect";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";

const schema = yup.object().shape({
  first_name: yup.string().required("First Name is required"),
  orgnization_name: yup.string().required("First Name is required"),

  last_name: yup.string().required("Last Name is required"),
  orgnization_email: yup
    .string()
    .email("Invalid email")
    .required("Email is required"),
  phone_number: yup
    .string()
    .matches(/^\d{10}$/, "Phone number must be 10 digits")
    .required("Phone number is required"),
  portal_name: yup.string().required("Profession is required"),
  requested_demo_for_product_name: yup
    .string()
    .required("Please describe your idea"),
  contactTime: yup.string().required("Select a convenient time"),
});

const ContactForm = () => {
  const {
    control,
    handleSubmit,
    reset,
    formState: { errors, isSubmitting },
  } = useForm({});

  const [captchaValue, setCaptchaValue] = useState(null);

  const onSubmit = async (data) => {
    if (!captchaValue) {
      alert("Please complete the CAPTCHA");
      return;
    }

    const payload = {
      ...data,
      form_type: "founder",
    };

    try {
      const response = await axios.post(
        "https://sfrv2dwdgc.execute-api.us-east-1.amazonaws.com/dev/akscel-demo-service/akscel_demo_model/create",
        payload
      );
      console.log("Form Submitted:", response.data);
      alert("Form submitted successfully!");
      reset();
    } catch (error) {
      console.error("Submission error:", error);
      alert("Failed to submit the form. Please try again.");
    }
  };

  return (
    <Grid container spacing={0} className={styles.container}>
      {/* Left Side Content */}
      <Grid item xs={12} md={6}>
        <Typography
          variant="h4"
          align="start"
          fontWeight="bold"
          paddingBottom={2}
          paddingTop={4}
          gutterBottom
          className={styles.gradientText}
        >
          Join the Founders program
        </Typography>
        <Typography variant="body1" style={{ marginBottom: "30px" }}>
          Limited Spots Available - Apply Today
        </Typography>

        <img
          src="images/FoundersContactImage.png"
          alt="contactimage"
          className={styles.image}
        />
      </Grid>

      {/* Right Side Contact Form */}
      <Grid item xs={12} md={6}>
        <Box className={styles.formContainer}>
          <Typography
            variant="h5"
            align="center"
            fontWeight="bold"
            paddingBottom={0}
            gutterBottom
          >
            Contact US
          </Typography>
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            <form onSubmit={handleSubmit(onSubmit)}>
              <Grid
                container
                spacing={2}
                lg={12}
                xs={12}
                sx={{ color: "#5E5A57" }}
              >
                <Grid item xs={12} sm={6} md={6}>
                  <Typography paddingTop={0} variant="body2">
                    First Name *
                  </Typography>
                  <Controller
                    name="first_name"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="standard"
                        placeholder="Enter"
                        margin=""
                        error={!!errors.first_name}
                        helperText={errors.first_name?.message}
                        InputProps={{
                          style: {
                            fontSize: "12px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography paddingTop={0} variant="body2">
                    Last Name *
                  </Typography>

                  <Controller
                    name="last_name"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="standard"
                        placeholder="Enter"
                        margin=""
                        error={!!errors.last_name}
                        helperText={errors.last_name?.message}
                        InputProps={{
                          style: {
                            fontSize: "12px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography paddingTop={0} variant="body2">
                    Email *
                  </Typography>

                  {/* Email */}
                  <Controller
                    name="orgnization_email"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="standard"
                        placeholder="Enter"
                        margin=""
                        error={!!errors.orgnization_email}
                        helperText={errors.orgnization_email?.message}
                        InputProps={{
                          style: {
                            fontSize: "12px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12} sm={6} md={6}>
                  <Typography paddingTop={0} variant="body2">
                    Phone Number *
                  </Typography>

                  {/* Phone Number */}
                  <Controller
                    name="phone_number"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="standard"
                        placeholder="Enter"
                        margin=""
                        error={!!errors.phone_number}
                        helperText={errors.phone_number?.message}
                        InputProps={{
                          style: {
                            fontSize: "12px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Typography paddingTop={0} variant="body2">
                    Enter Your current profession *
                  </Typography>

                  {/* Profession */}
                  <Controller
                    name="current_profession"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="standard"
                        placeholder="Enter"
                        error={!!errors.current_profession}
                        helperText={errors.current_profession?.message}
                        InputProps={{
                          style: {
                            fontSize: "12px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12} sm={6} md={6}>
                  <Typography paddingTop={0} variant="body2">
                    Organization Name *
                  </Typography>
                  <Controller
                    name="orgnization_name"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="standard"
                        placeholder="Enter"
                        margin=""
                        error={!!errors.orgnization_name}
                        helperText={errors.orgnization_name?.message}
                        InputProps={{
                          style: {
                            fontSize: "12px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>

                <Grid item xs={12}>
                  <Typography paddingTop={0} variant="body2">
                    Please specify the Idea in brief - and/or is it ready for
                    development of MVP? *
                  </Typography>

                  {/* Idea */}
                  <Controller
                    name="idea_brief"
                    control={control}
                    defaultValue=""
                    render={({ field }) => (
                      <TextField
                        {...field}
                        fullWidth
                        variant="standard"
                        placeholder="Your Answer"
                        error={!!errors.idea_brief}
                        helperText={errors.idea_brief?.message}
                        InputProps={{
                          style: {
                            fontSize: "12px",
                          },
                        }}
                      />
                    )}
                  />
                </Grid>
                <Grid item xs={12}>
                  <Typography paddingTop={0} variant="body2">
                    What would be the convenient time of day to contact you?
                  </Typography>

                  {/* Time Selection */}

                  <Controller
                    name="convenient_time"
                    control={control}
                    rules={{ required: "Contact time is required" }}
                    render={({ field }) => (
                      <DateTimePicker
                        {...field}
                        ampm={true}
                        format="DD/MM/YYYY hh:mm A"
                        minDateTime={dayjs()}
                        slotProps={{
                          textField: {
                            fullWidth: true,
                            variant: "standard",
                            margin: "normal",
                            error: !!errors.convenient_time,
                            helperText: errors.convenient_time?.message,
                            placeholder: "DD/MM/YYYY AM/PM",
                            InputProps: {
                              style: { fontSize: "12px" },
                            },
                            inputProps: {
                              placeholder: "DD/MM/YYYY AM/PM",
                            },
                          },
                        }}
                      />
                    )}
                  />
                  
                  <Typography paddingTop={2} variant="body2">
                    Select your Timezone
                  </Typography>

                  <TimezoneSelect control={control} errors={errors} />
                </Grid>
                <Box sx={{ mt: 3, mb: 1, ml: 2 }}>
                  <ReCAPTCHA
                    sitekey="6LcXCt0pAAAAAD64OSyAnmuhMBG3Xa7IQPaWNo3N"
                    onChange={(value) => setCaptchaValue(value)}
                  />
                </Box>
                <Grid item xs={12}>
                  <Button
                    type="submit"
                    variant="contained"
                    disabled={isSubmitting}
                    sx={{
                      mt: 0,
                      paddingLeft: 4,
                      paddingRight: 4,
                      paddingTop: 1,
                      paddingBottom: 1,
                      background: "linear-gradient(to right, #1995FC, #C416FF)",
                      color: "#fff",
                      "&:hover": { opacity: 0.9 },
                    }}
                  >
                    {isSubmitting ? "Submitting..." : "Submit"}
                  </Button>
                </Grid>
              </Grid>
            </form>
          </LocalizationProvider>
        </Box>
      </Grid>
    </Grid>
  );
};

export default ContactForm;
